import React from 'react';
import {Trans} from 'react-i18next';
import { withTranslation } from 'react-i18next';
import {connect} from 'react-redux';
import {
	getSharingDetailsPopup
} from '../../../../../../../actions/sharingDetailsActions';
import Icon from "../../../../../../components/icon";
import Button from "../../../../../../components/button";

class GetShareableLinkPopupMessage extends React.Component {

    constructor(props){
        super(props);

        this.send = this.send.bind(this);
        this.close = this.close.bind(this);
    }

    send(){
        window.open('https://mail.google.com/mail/u/0/?view=cm&fs=1&su=' + this.props.profile.name + ' shared contacts with you' +
            '&body=Hello,%0A%0AI am sharing my group of contacts called ' + this.props.selectedContactsGroup.name + ' with you.%0A%0A' +
	        'To accept the invitation, please click on this link: ' + window.location.origin + '/invited' +
            '%0A%0A--%0ABest regards,%0A'+
            this.props.profile.name +'&tf=1',
            'Send email',
            '_blank,width=990,height=600');
        this.props.getSharingDetailsPopup([]);
	}

	close(){
        this.props.getSharingDetailsPopup([]);
	}

    render() {
    	if(this.props.enabled){
            return (
                <div>
                    <h2>Get shareable link</h2>
                    <p>{this.props.t("shareLinkText1")}.</p>
                    <p>{this.props.t("link")}: <a href={`/invited`}>{window.location.origin}/invited</a></p>
                    <Button onClick={this.send} className="btn-default float-right">{this.props.t("sendText")}</Button>
                </div>
            );
		} else {
            return (
                <div>
                    <h2><Icon name={"warning"} className="text-warning"/> <span className="text-warning">{this.props.t("textUpgradeNow")}</span></h2>
                    <p><Trans i18nKey="getShareablePopupText1" values={{plan_name:"ENTERPRISE"}}/></p>
                    <a onClick={this.close} className="btn btn-default float-right" href={`/api/payment/upgrade`} target="_blank" rel="noreferrer">{this.props.t("upgradeText")}</a>
                </div>
            );
		}

    }
}

const mapStateToProps = (state) => {
	return {
		profile : state.profileReducer.getProfile,
        selectedContactsGroup : state.contactsGroupItemReducer.getSelectedContactsGroup
	};
};


const mapDispatchToProps = (dispatch) => {
	return {
        getSharingDetailsPopup : (boolean) => {
			dispatch(getSharingDetailsPopup(boolean))
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(GetShareableLinkPopupMessage));